import { useMemo } from "react";

export default function useRights() {
  return useMemo(() => {
    try {
      return JSON.parse(
        localStorage.getItem(import.meta.env.VITE_APP_NAME + "-rights") ?? "{}",
      ) as Record<string, string>;
    } catch {
      return {} as Record<string, string>;
    }
  }, []);
}
export function hasRight(
  rights: Record<string, unknown> | undefined,
  name: string,
): boolean {
  return !!rights && Object.prototype.hasOwnProperty.call(rights, name);
}
